import { render, staticRenderFns } from "./ProductEditCard.vue?vue&type=template&id=2249f6e4&scoped=true"
import script from "./ProductEditCard.vue?vue&type=script&lang=ts"
export * from "./ProductEditCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditCard.vue?vue&type=style&index=0&id=2249f6e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249f6e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2249f6e4')) {
      api.createRecord('2249f6e4', component.options)
    } else {
      api.reload('2249f6e4', component.options)
    }
    module.hot.accept("./ProductEditCard.vue?vue&type=template&id=2249f6e4&scoped=true", function () {
      api.rerender('2249f6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditCard.vue"
export default component.exports